<template>
  <div class="">
    <div class="text-right mb-2">
      <button @click="getReport()" class="btn btn-success rounded-pill">
        <span class="ml-1">بارگذاری مجدد</span>
        <b-icon icon="arrow-clockwise"/>
      </button>
    </div>
    <div class="text-center">
      <div v-if="requestStatus">

        <div v-if="reports.length > 0">

          <table class="table table-striped">
            <thead>
            <tr>
              <th>شماره تلفن</th>
              <td>وضعیت</td>
              <td>گزارش</td>
              <td>تاریخ ایجاد</td>
              <td>اخرین به روز رسانی</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in reports">
              <th>{{ item.cellphone }}</th>
              <td>{{ item.status.status_name }}</td>
              <td>{{ reportManager(item) }}</td>
              <td>{{ dateConverter(item.created_at, '/', true) }}</td>
              <td>{{ item.updated_at == null ? '' : dateConverter(item.updated_at, '/', true) }}</td>
            </tr>
            </tbody>
          </table>

        </div>
        <div v-else>
          <p>موردی یافت نشد</p>
        </div>

      </div>
      <div v-else>
        <b-spinner type="grow" label="Loading..."></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "SmsReport",
  props: {
    sms: {
      default: null
    }
  },
  data() {
    return {
      reports: [],
      requestStatus: false
    }
  },
  methods: {
    dateConverter,
    reportManager(item) {
      if (this.sms.type == 0) { // template
        return 'با موفقیت ارسال شد'
      }
      return ''
    },
    getReport() {
      this.requestStatus = false
      let form = {
        sms_id: this.sms.id
      }
      let req = this.$store.dispatch('Sms/getSmsReport', form)
      req.then(res => {
        this.requestStatus = true
        this.reports = res.data.data
      })
          .catch(error => {
            this.requestStatus = true
            console.log(error)
          })
    }
  },
  async mounted() {
    this.getReport()
  }
}
</script>

<style scoped>

</style>